import React, { Fragment } from "react";
import { getDistance, convertDistance } from "geolib";
import {
  f7,
  Page,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col,
  Popup,
  Toggle,
  Range,
  Preloader,
  TextEditor,
  Badge,
  Popover,
  Sheet,
  PageContent,
} from "framework7-react";

import { ChefSvg, Emoticons, Emoji } from "../components/crumbs";

import { compose } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { firestoreConnect } from "../HOCs";
import { Collections } from "../utils/_classes";
import {
  toast,
  handleErrors,
  totalProductPrice,
  checkFreeDelivery,
  isMerchantOpen,
  getCurrentTime,
} from "../utils/_helpers";

import { CART } from "../store/actions/cart";

// image viewer from https://www.npmjs.com/package/react-medium-image-zoom
import { Controlled as ControlledZoom } from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

class Store extends React.Component {
  constructor(props) {
    super(props);
    var merchant = props.f7route.params.merchantID;

    this.state = {
      popupOpened: false,
      popupDataChanged: true,

      currentDateTime: null,
      dateTimeInterval: null,

      which: merchant,
      addOrderButton: "Add to Cart",
      popupData: {
        productName: "",
        price: "",
        image: "",
        count: 1,
        productId: "",
        stocked: "",
        merchantId: "",
        merchantName: "",
        text: "",
        preparationTime: 0,
        discount: "",
        delivery: true,
        deliveryMeans: "",
      },

      shortOperationDays: {
        Sunday: "Sun",
        Monday: "Mon",
        Tuesday: "Tue",
        Wednesday: "Wed",
        Thursday: "Thur",
        Friday: "Fri",
        Saturday: "Sat",
      },

      // Rating
      ratingButton: "Submit Review",
      rating: {
        userId: "",
        email: "",
        rating: 4,
        review: "",
      },

      //merchant details
      merchantDetails: null,

      // image zoom
      isZoomed: false,
    };
  }

  get preparationTimeComputed() {
    const self = this;
    const value = self.state.popupData.preparationTime;

    const days = Math.floor(value / 60 / 24);
    const hours = Math.floor((value - days * 60 * 24) / 60);
    const minutes = value - Math.floor(value / 60) * 60;
    const formatted = [];

    if (days > 0) {
      formatted.push(days + " " + (days > 1 ? "days" : "day"));
    }
    if (hours > 0) {
      formatted.push(hours + " " + (hours > 1 ? "hours" : "hour"));
    }
    if (minutes > 0) {
      formatted.push(minutes + " minutes");
    }
    return formatted.join(" ");
  }

  render() {
    return (
      <Page
        id="store-front"
        hideToolbarOnScroll
        onPageAfterIn={this.onPageAfterIn.bind(this)}
      >
        <Navbar>
          <NavLeft>
            <Link iconF7="chevron_left" href="/discover/">
              Find Restaurants
            </Link>
          </NavLeft>
          <NavTitle sliding>
            {this.props.data.merchants &&
              this.props.data.merchants[this.props.f7route.params.merchantID] &&
              this.props.data.merchants[this.props.f7route.params.merchantID]
                .businessProfile.name}
          </NavTitle>
          <NavRight>
            <Link iconOnly href="/cart/" className="glow-tag glow-4x">
              <Icon f7="cart" size="20px">
                <Badge color="red">
                  {this.props.cart === null
                    ? "0"
                    : this.props.cart
                        .map((cartObject) =>
                          cartObject.packages
                            .map((product) => product.count)
                            .reduce((a, b) => Number(a) + Number(b), 0)
                        )
                        .reduce((a, b) => Number(a) + Number(b), 0)}
                </Badge>
                <input
                  type="hidden"
                  value={
                    this.props.cart === null
                      ? "0"
                      : this.props.cart
                          .map((cartObject) =>
                            cartObject.packages
                              .map((product) => product.count)
                              .reduce((a, b) => Number(a) + Number(b), 0)
                          )
                          .reduce((a, b) => Number(a) + Number(b), 0)
                  }
                  onChange={this.$f7.methods.glow()}
                />
              </Icon>
            </Link>
          </NavRight>
        </Navbar>
        {/* {Page content} */}

        {/* [Desktop only store banner] */}
        <div
          style={
            parseInt(window.innerWidth) > 800
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <Row noGap>
            <Col width="60">
              <div
                className="discover-cards store-front-hero overlay"
                style={
                  this.props.data.merchants &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ] &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ].banner
                    ? {
                        backgroundImage:
                          "url(" +
                          this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ].banner.URL +
                          "), url(static/picloading1.gif), radial-gradient(rgb(253 202 3), rgb(236 188 0)",
                      }
                    : { backgroundImage: "url(static/poster.png)" }
                }
                alt="merchant banner"
              >
                {!isMerchantOpen(
                  this.state.currentDateTime,
                  this.props.data.merchants?.[
                    this.props.f7route.params.merchantID
                  ].businessProfile.operationDays,
                  this.props.data.merchants?.[
                    this.props.f7route.params.merchantID
                  ].businessProfile.operationTimes,
                  this.props.data.merchants?.[
                    this.props.f7route.params.merchantID
                  ].businessProfile.operationStartTime,
                  this.props.data.merchants?.[
                    this.props.f7route.params.merchantID
                  ].businessProfile.operationCloseTime
                ) ? (
                  <Badge
                    slot="title"
                    color="red"
                    style={{ borderRadius: 0, padding: 16, zIndex: 1 }}
                  >
                    Sorry, We Are Closed
                  </Badge>
                ) : (
                  <Badge
                    slot="title"
                    color="green"
                    style={{ borderRadius: 0, padding: 16, zIndex: 1 }}
                  >
                    We Are Open
                  </Badge>
                )}
              </div>
            </Col>

            <Col width="40">
              <Card style={{ borderRadius: 0, margin: 0 }}>
                <CardHeader
                  className="no-border bg-color-jasmine bg-image-pattern"
                  style={{
                    backgroundSize: "30%",
                    height: "25vh",
                  }}
                >
                  <img
                    src={
                      this.props.data.merchants &&
                      this.props.data.merchants[
                        this.props.f7route.params.merchantID
                      ] &&
                      this.props.data.merchants[
                        this.props.f7route.params.merchantID
                      ].businessProfile.images.logo.URL
                        ? this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ].businessProfile.images.logo.URL
                        : "static/poster.png"
                    }
                    alt="merchant logo"
                    style={{
                      width: "15vh",
                      height: "15vh",
                      objectFit: "cover",
                      margin: "auto",
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                    }}
                    className="shadow"
                  />
                </CardHeader>
              </Card>

              <Card style={{ borderRadius: 0, margin: 0 }}>
                <CardHeader
                  style={{
                    fontSize: "24px",
                    whiteSpace: "nowrap",
                    overflow: "scroll",
                    fontFamily: "Italiana",
                  }}
                >
                  {this.props.data.merchants &&
                    this.props.data.merchants[
                      this.props.f7route.params.merchantID
                    ] &&
                    this.props.data.merchants[
                      this.props.f7route.params.merchantID
                    ].businessProfile.name}
                  {/* Verified Badge */}
                  {this.props.data.merchants &&
                    this.props.data.merchants[
                      this.props.f7route.params.merchantID
                    ] &&
                    (this.props.data.merchants[
                      this.props.f7route.params.merchantID
                    ]?.verified ? (
                      <Icon f7="checkmark_seal_fill" color="blue" />
                    ) : null)}
                </CardHeader>
                <CardContent>
                  <List>
                    <ListItem tooltip="Merchant's credibity score">
                      <span slot="title">
                        Completion Rate <Icon f7="info_circle" />
                      </span>
                      <Badge slot="after" color="yellow">
                        {this.props.data.merchants &&
                          this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ] &&
                          (this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ]?.score
                            ? Math.floor(
                                (this.props.data.merchants[
                                  this.props.f7route.params.merchantID
                                ]?.score?.success /
                                  this.props.data.merchants[
                                    this.props.f7route.params.merchantID
                                  ]?.score?.total) *
                                  100
                              ) + "%"
                            : "0%")}
                      </Badge>
                    </ListItem>

                    <ListItem title="Distance">
                      <small slot="after">
                        {this.props.data.merchants &&
                          this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ] &&
                          convertDistance(
                            getDistance(
                              this.props.discover.geoLoc,
                              this.props.data.merchants[
                                this.props.f7route.params.merchantID
                              ].businessProfile.geoLoc
                            ),
                            "km"
                          ).toFixed(2) + "km away"}
                      </small>
                    </ListItem>

                    <ListItem title="Located In">
                      <small slot="after">
                        {this.state.merchantDetails?.city
                          ? this.state.merchantDetails?.city
                          : "City"}
                      </small>
                    </ListItem>

                    <ListItem title="Merchant Rating">
                      <small slot="after">
                        {this.props.data.merchants &&
                        this.props.data.merchants[
                          this.props.f7route.params.merchantID
                        ] &&
                        this.props.data.merchants[
                          this.props.f7route.params.merchantID
                        ].ratings &&
                        this.props.data.merchants[
                          this.props.f7route.params.merchantID
                        ].ratings.length > 0 ? (
                          <strong>
                            {this.props.data.merchants[
                              this.props.f7route.params.merchantID
                            ].ratings &&
                              (
                                this.props.data.merchants[
                                  this.props.f7route.params.merchantID
                                ].ratings
                                  .map((r) => r.rating)
                                  .reduce((a, b) => +a + +b, 0) /
                                this.props.data.merchants[
                                  this.props.f7route.params.merchantID
                                ].ratings.length
                              ).toFixed(2)}
                            &nbsp;
                            <i
                              className="f7-icons"
                              style={{ fontSize: "10px" }}
                            >
                              star_fill
                            </i>
                          </strong>
                        ) : (
                          <strong>No ratings</strong>
                        )}
                      </small>
                    </ListItem>
                  </List>
                </CardContent>
                <CardFooter>
                  <Row style={{ width: "100%" }}>
                    <Col width="45">
                      <Button fill round popupOpen=".rating-popup">
                        Read Ratings
                      </Button>
                    </Col>

                    <Col width="45">
                      <Button
                        fill
                        round
                        onClick={() => {
                          f7.sheet.open(".store-details-sheet");
                        }}
                      >
                        More Info
                      </Button>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </div>

        {/* [Mobile only store banner] */}
        <div
          style={
            parseInt(window.innerWidth) < 800
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <div
            className="discover-cards store-front-hero overlay"
            style={
              this.props.data.merchants &&
              this.props.data.merchants[this.props.f7route.params.merchantID] &&
              this.props.data.merchants[this.props.f7route.params.merchantID]
                .banner
                ? {
                    backgroundImage:
                      "url(" +
                      this.props.data.merchants[
                        this.props.f7route.params.merchantID
                      ].banner.URL +
                      "), url(static/picloading1.gif), radial-gradient(rgb(253 202 3), rgb(236 188 0)",
                  }
                : { backgroundImage: "url(static/poster.png)" }
            }
            alt="merchant banner"
          >
            {!isMerchantOpen(
              this.state.currentDateTime,
              this.props.data.merchants?.[this.props.f7route.params.merchantID]
                .businessProfile.operationDays,
              this.props.data.merchants?.[this.props.f7route.params.merchantID]
                .businessProfile.operationTimes,
              this.props.data.merchants?.[this.props.f7route.params.merchantID]
                .businessProfile.operationStartTime,
              this.props.data.merchants?.[this.props.f7route.params.merchantID]
                .businessProfile.operationCloseTime
            ) ? (
              <Badge
                slot="title"
                color="red"
                style={{ borderRadius: 0, padding: 16, zIndex: 1 }}
              >
                Sorry, We Are Closed
              </Badge>
            ) : (
              <Badge
                slot="title"
                color="green"
                style={{ borderRadius: 0, padding: 16, zIndex: 1 }}
              >
                We Are Open
              </Badge>
            )}
          </div>

          <Card style={{ borderRadius: 0, margin: 0 }}>
            <CardContent className="no-padding">
              <div
                className="flex flex-row find-card"
                style={{ boxShadow: "none", minHeight: 70 }}
              >
                <div
                  className="find-card-text"
                  style={{ padding: "8px 16px 0px 16px" }}
                >
                  <div className="flex flex-col">
                    <div>
                      <h2>
                        {this.props.data.merchants &&
                          this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ] &&
                          this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ].businessProfile.name}
                      </h2>
                      {/* Verified Badge */}
                      {this.props.data.merchants &&
                        this.props.data.merchants[
                          this.props.f7route.params.merchantID
                        ] &&
                        (this.props.data.merchants[
                          this.props.f7route.params.merchantID
                        ]?.verified ? (
                          <Icon
                            f7="checkmark_seal_fill"
                            color="blue"
                            style={{ fontSize: 12, padding: 6 }}
                          />
                        ) : null)}
                    </div>

                    {/* Merchant city */}
                    <div>
                      <small>
                        {this.state.merchantDetails?.city
                          ? this.state.merchantDetails?.city
                          : "City"}
                      </small>
                    </div>

                    {/* Merchant completion rate */}
                    <div>
                      <Button
                        popoverOpen=".popover-credibility"
                        style={{
                          padding: 0,
                          textAlign: "left",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>
                          Completion rate <Icon f7="info_circle" />
                        </span>
                        <strong>
                          {this.props.data.merchants &&
                            this.props.data.merchants[
                              this.props.f7route.params.merchantID
                            ] &&
                            (this.props.data.merchants[
                              this.props.f7route.params.merchantID
                            ]?.score
                              ? Math.floor(
                                  (this.props.data.merchants[
                                    this.props.f7route.params.merchantID
                                  ]?.score?.success /
                                    this.props.data.merchants[
                                      this.props.f7route.params.merchantID
                                    ]?.score?.total) *
                                    100
                                ) + "%"
                              : "0%")}
                        </strong>
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="find-card-image">
                  <img
                    src={
                      this.props.data.merchants &&
                      this.props.data.merchants[
                        this.props.f7route.params.merchantID
                      ] &&
                      this.props.data.merchants[
                        this.props.f7route.params.merchantID
                      ].businessProfile.images.logo.URL
                        ? this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ].businessProfile.images.logo.URL
                        : "static/poster.png"
                    }
                    style={{ borderRadius: 0 }}
                    alt="merchant logo"
                  />
                </div>
              </div>
            </CardContent>
            <CardFooter>
              <Row className="easyPrintText" style={{ width: "100%" }}>
                <Col width="25">
                  <Button fill round popupOpen=".rating-popup">
                    Reviews
                  </Button>
                </Col>
                <Col width="35">
                  <pre style={{ textAlign: "center", borderRadius: "40px" }}>
                    <small>
                      {this.props.data.merchants &&
                        this.props.data.merchants[
                          this.props.f7route.params.merchantID
                        ] &&
                        convertDistance(
                          getDistance(
                            this.props.discover.geoLoc,
                            this.props.data.merchants[
                              this.props.f7route.params.merchantID
                            ].businessProfile.geoLoc
                          ),
                          "km"
                        ).toFixed(2) + "km away"}
                    </small>
                  </pre>
                </Col>
                <Col width="40">
                  <Button
                    fill
                    round
                    onClick={() => {
                      f7.sheet.open(".store-details-sheet");
                    }}
                  >
                    More Info
                  </Button>
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </div>

        <Popover className="popover-credibility">
          <p style={{ margin: 12 }}>Merchant's credibility score</p>
        </Popover>

        {/* [Card-1] Merchant Menu */}
        <Card
          className="data-table data-table-init"
          style={{ borderRadius: 0, margin: 0 }}
        >
          <CardHeader>
            <div className="data-table-title">Menu</div>
          </CardHeader>
          <CardContent padding={false}>
            <table>
              <thead>
                <tr>
                  {this.props.data.merchants &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ] &&
                  this.props.data.merchants[this.state.which].menuCategories
                    ? this.props.data.merchants[this.state.which].menuCategories
                        .sort()
                        .map((value, index) => (
                          <th
                            className="label-cell"
                            key={index}
                            onClick={(event) => {
                              this.$f7.methods.scrollTo(
                                this.$f7,
                                `#menu-${value.trim().split(" ").join("")}`
                              );
                            }}
                          >
                            <small>{value}</small>
                          </th>
                        ))
                    : null}
                </tr>
              </thead>
            </table>
          </CardContent>
        </Card>

        {/* {Load merchant's products here} */}
        <div style={{ paddingBottom: "30px" }}>
          {this.props.ordered.loading && !this.props.ordered.products ? (
            <Block className="text-align-center">
              <Preloader></Preloader>
            </Block>
          ) : !this.props.ordered.loading &&
            (!this.props.ordered.products ||
              this.props.ordered.products.length === 0 ||
              this.props.ordered.products.filter(
                (p) => p.merchantId === this.props.f7route.params.merchantID
              ).length === 0) ? (
            <div
              style={{
                margin: "20vh auto 0 auto",
                width: "220px",
                textAlign: "center",
              }}
            >
              <ChefSvg size="220px" />
              No options found here...
            </div>
          ) : (
            [
              ...new Set(
                this.props.ordered.products
                  .filter(
                    (p) =>
                      p.merchantId === this.props.f7route.params.merchantID &&
                      p.available !== false
                  )
                  .map((p) => p.category)
              ),
            ]
              .sort()
              .map((category) => (
                <Fragment key={category}>
                  <BlockTitle
                    id={`menu-${category.trim().split(" ").join("")}`}
                  >
                    {category}
                  </BlockTitle>
                  <Row className="justify-start">
                    {this.props.ordered.products
                      .filter(
                        (p) =>
                          p.merchantId ===
                            this.props.f7route.params.merchantID &&
                          p.category === category
                      )
                      .map(
                        ({
                          id,
                          name,
                          image,
                          price,
                          merchantId,
                          text,
                          discount,
                          available,
                          stocked,
                          preparationTime,
                          delivery,
                          deliveryMeans,
                        }) => (
                          <Col
                            key={id}
                            width="100"
                            xsmall="50"
                            large="33"
                            xlarge={
                              parseInt(
                                document.getElementById("store-front")
                                  ?.offsetWidth
                              ) < 1400
                                ? "33"
                                : "25"
                            }
                            className={`${
                              available === false ? "hide" : "show"
                            }`}
                            onClick={() => {
                              if (
                                available === false ||
                                (stocked !== "" && parseInt(stocked) < 1)
                              ) {
                                return toast(this.$f7.toast, {
                                  text: "Unavailable at the moment",
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              }
                              this.openPopup({
                                productName: name,
                                price: price,
                                image: image.URL,
                                productId: id,
                                merchantId,
                                stocked,
                                merchantName:
                                  this.props.data.merchants &&
                                  this.props.data.merchants[
                                    this.props.f7route.params.merchantID
                                  ] &&
                                  this.props.data.merchants[merchantId]
                                    .businessProfile.name,
                                merchantGeoLoc:
                                  this.props.data.merchants &&
                                  this.props.data.merchants[
                                    this.props.f7route.params.merchantID
                                  ] &&
                                  this.props.data.merchants[merchantId]
                                    .businessProfile.geoLoc,
                                text,
                                preparationTime,
                                discount,
                                delivery,
                                deliveryMeans,
                              });
                            }}
                          >
                            <Card
                              className={` ${
                                stocked !== "" && parseInt(stocked) < 1
                                  ? "soldout"
                                  : ""
                              }`}
                              style={{
                                overflow: "hidden",
                              }}
                            >
                              <Row noGap>
                                <Col width="60">
                                  <List className="noFullText">
                                    <ListItem>
                                      <p className="item-name" slot="title">
                                        {name.length > 20
                                          ? name
                                              .substring(0, 25)
                                              .trim()
                                              .concat("...")
                                          : name}
                                      </p>
                                      <p className="item-stock" slot="title">
                                        <small>
                                          {text.length > 20
                                            ? text
                                                .substring(0, 27)
                                                .trim()
                                                .concat("...")
                                            : text.length <= 0
                                            ? "No product description"
                                            : text}
                                        </small>
                                      </p>

                                      {/* Only show if there's a stock quantity or out of stock*/}
                                      <p className="item-stock" slot="title">
                                        <small>
                                          {stocked !== "" || +stocked > 0
                                            ? `${stocked} left`
                                            : stocked === ""
                                            ? "Stocked"
                                            : "Out of Stock"}
                                        </small>
                                      </p>

                                      {/* Only show if there's a discount */}
                                      {discount !== "" ? (
                                        <small
                                          className="item-price"
                                          slot="title"
                                        >
                                          <s style={{ color: "orange" }}>
                                            {new Intl.NumberFormat("en-GB", {
                                              style: "currency",
                                              currency: "NGN",
                                            }).format(totalProductPrice(price))}
                                          </s>
                                          &nbsp;&nbsp;
                                        </small>
                                      ) : null}

                                      {/* Use this to show prices after discount or if no discount*/}
                                      <small
                                        className="item-price"
                                        slot="title"
                                      >
                                        {discount !== ""
                                          ? new Intl.NumberFormat("en-GB", {
                                              style: "currency",
                                              currency: "NGN",
                                            }).format(
                                              totalProductPrice(price, discount)
                                            )
                                          : new Intl.NumberFormat("en-GB", {
                                              style: "currency",
                                              currency: "NGN",
                                            }).format(totalProductPrice(price))}
                                      </small>
                                    </ListItem>
                                  </List>
                                </Col>

                                <Col
                                  width="40"
                                  style={{
                                    backgroundImage:
                                      "url(static/icon-512x512@1x.png)",
                                    backgroundSize: "cover",
                                    maxHeight: "140px",
                                  }}
                                >
                                  <img
                                    className="item-image"
                                    src={image.URL}
                                    alt="item logo"
                                    style={{
                                      opacity: 0.98,
                                    }}
                                  />
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        )
                      )}
                  </Row>
                </Fragment>
              ))
          )}
        </div>

        {/* Popup menu items to add to cart */}
        <Popup
          swipeToClose="to-bottom"
          className="item-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() => {
            this.setState({
              ...this.state,
              popupOpened: false,
            });
            this.$f7.card.close(".product-image", false);
          }}
        >
          <Page>
            <Navbar>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
              <NavTitle sliding>{this.state.popupData.productName}</NavTitle>
            </Navbar>
            <Block>
              <Card style={{ margin: "auto" }}>
                <CardContent className="no-padding">
                  <div className="store-product-image-container">
                    <ControlledZoom
                      isZoomed={this.state.isZoomed}
                      onZoomChange={this.handleZoomChange.bind(this)}
                    >
                        <img
                          src={
                            this.state.popupData.image ||
                            "static/icon-512x512@1x.png"
                          }
                          className={this.state.isZoomed ? "" : "unzoomed"}
                        />
                        <h1 className="product-name">
                          {this.state.popupData.productName}
                        </h1>
                    </ControlledZoom>
                  </div>
                </CardContent>
              </Card>
              <Card style={{ margin: "10pt auto", zIndex: 0 }}>
                <CardHeader className="no-border">
                  Product Description
                </CardHeader>
                <CardContent padding={false}>
                  <Block style={{ margin: "20pt auto" }}>
                    <p>{this.state.popupData.text}</p>
                  </Block>

                  <List
                    style={{ margin: "20pt auto 0pt" }}
                    className="bg-color-cultured"
                  >
                    <ListItem title="Preparation Time">
                      <small slot="after">{this.preparationTimeComputed}</small>
                      <Icon slot="media" f7="timer"></Icon>
                    </ListItem>
                    <ListItem
                      title="Delivery Type"
                      badge={
                        this.state.popupData.delivery ? "Delivery" : "Pick Up"
                      }
                      badgeColor={
                        this.state.popupData.delivery ? "green" : "orange"
                      }
                    >
                      {this.state.popupData.deliveryMeans &&
                      this.state.popupData.deliveryMeans === 2 ? (
                        <Icon slot="media" f7="car_fill"></Icon>
                      ) : (
                        <img
                          slot="media"
                          src="static/bike-1.svg"
                          alt=""
                          width="18px"
                        />
                      )}
                    </ListItem>
                  </List>
                </CardContent>
                <CardFooter>
                  <Row style={{ width: "100%" }}>
                    <Col width="60">
                      <Row noGap>
                        <Col width="30">
                          <List style={{ zIndex: 0 }}>
                            <ListInput
                              autofocus
                              type="number"
                              name="count"
                              placeholder="1"
                              required
                              pattern="[0-9]"
                              validate
                              min="1"
                              value={this.state.popupData.count}
                              onBlur={(e) =>
                                this.setState({
                                  ...this.state,
                                  popupData: {
                                    ...this.state.popupData,
                                    count:
                                      e.target.value !== "" &&
                                      parseInt(e.target.value) !== "NaN" &&
                                      parseInt(e.target.value) !== 0 &&
                                      parseInt(e.target.value) > 0
                                        ? parseInt(e.target.value)
                                        : 1,
                                  },
                                })
                              }
                              onChange={(e) => {
                                if (
                                  parseInt(e.target.value) !== "NaN" &&
                                  this.props.data.products[
                                    this.state.popupData.productId
                                  ].stocked !== "" &&
                                  parseInt(e.target.value) >
                                    parseInt(
                                      this.props.data.products[
                                        this.state.popupData.productId
                                      ].stocked
                                    )
                                ) {
                                  toast(this.$f7.toast, {
                                    text: "We dont have up to this number stocked",
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                  this.setState({
                                    ...this.state,
                                    popupData: {
                                      ...this.state.popupData,
                                      count: parseInt(
                                        this.props.data.products[
                                          this.state.popupData.productId
                                        ].stocked
                                      ),
                                    },
                                  });
                                } else {
                                  this.setState({
                                    ...this.state,
                                    popupData: {
                                      ...this.state.popupData,
                                      count: e.target.value,
                                    },
                                  });
                                }
                              }}
                              className="custom-count-input"
                            ></ListInput>
                          </List>
                        </Col>
                        <Col width="70">
                          <pre
                            style={{
                              marginTop: "0px",
                              backgroundColor: "#f3f3f3",
                              textAlign: "center",
                              padding: "8.5px 0",
                              border: "1px solid hsla(0, 0%, 90%, 1)",
                              borderTopRightRadius: "20px",
                              borderBottomRightRadius: "20px",
                            }}
                          >
                            {this.state.popupData.discount !== ""
                              ? new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  totalProductPrice(
                                    this.state.popupData.price *
                                      this.state.popupData.count,
                                    this.state.popupData.discount
                                  )
                                )
                              : new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  totalProductPrice(
                                    this.state.popupData.price *
                                      this.state.popupData.count
                                  )
                                )}
                          </pre>
                        </Col>
                      </Row>
                    </Col>

                    <Col width="40">
                      <Button
                        fill
                        round
                        disabled={
                          (this.state.popupData.stocked !== "" &&
                            (+this.state.popupData.stocked < 1 ||
                              this.state.popupData.count >
                                +this.state.popupData.stocked)) ||
                          this.state.popupData.count === "" ||
                          +this.state.popupData.count < 1
                        }
                        onClick={this.addOrder.bind(this)}
                        style={{
                          width: "100%",
                          color:
                            this.state.popupData.stocked !== "" &&
                            +this.state.popupData.stocked < 1
                              ? "red"
                              : "inherit",
                        }}
                      >
                        {this.state.addOrderButton !== "Add to Cart" ? (
                          <Preloader></Preloader>
                        ) : this.state.popupData.stocked !== "" &&
                          +this.state.popupData.stocked < 1 ? (
                          "Out of stock"
                        ) : (
                          this.state.addOrderButton
                        )}
                      </Button>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Block>
          </Page>
        </Popup>

        {/* Popup merchant ratings */}
        <Popup swipeToClose="to-bottom" className="rating-popup">
          <Page>
            <Navbar>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
              <NavTitle sliding>
                {this.props.data.merchants &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ] &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ].businessProfile.name}
              </NavTitle>
            </Navbar>

            <Block className="pattern-banner bg-color-oldlace">
              <Card style={{ width: "100%", margin: 0 }}>
                <CardHeader>
                  <h3 style={{ margin: 0 }}>Rate merchant service</h3>
                  {this.props.data.merchants &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ] &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ].ratings &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ].ratings.length > 0 ? (
                    <p>
                      Reviews: &nbsp;
                      <strong style={{ fontFamily: "serif" }}>
                        {this.props.data.merchants[
                          this.props.f7route.params.merchantID
                        ].ratings &&
                          `${
                            this.props.data.merchants[
                              this.props.f7route.params.merchantID
                            ].ratings.length
                          }`}
                      </strong>
                    </p>
                  ) : null}
                </CardHeader>
              </Card>
            </Block>

            {this.props.data.merchants &&
            this.props.data.merchants[this.props.f7route.params.merchantID] &&
            this.props.data.merchants[this.props.f7route.params.merchantID]
              .ratings &&
            this.props.data.merchants[this.props.f7route.params.merchantID]
              .ratings.length > 0 ? (
              <div className="ratingsPopupCards">
                {/* Load each review in a card; cardheader in lower cases only */}
                {this.props.data.merchants &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ] &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ].ratings &&
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ].ratings
                    .sort((a, b) => +a.timestamp - +b.timestamp || 0)
                    .map(({ rating, email, review, name }, i) => (
                      <div className="ratingCard" key={i}>
                        <Card>
                          <CardHeader>
                            <em>{name ? name : email.toLowerCase()} said:</em>{" "}
                            <Emoji user_rating={+rating} />
                          </CardHeader>
                          <CardContent>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: review,
                              }}
                            ></div>
                          </CardContent>
                        </Card>
                      </div>
                    ))}
              </div>
            ) : (
              <div style={{ textAlign: "center", marginTop: "12%" }}>
                <img src="static/feedback.svg" style={{ width: "300px" }} />
                <h6>This merchant has no reviews at the moment.</h6>
              </div>
            )}
          </Page>
        </Popup>

        <Toolbar position="bottom" id="menuBar" hidden>
          <table style={{ marginLeft: "-2px" }}>
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: "#161616",
                    color: "#fed448",
                    padding: "8px",
                    position: "fixed",
                    top: 0,
                  }}
                >
                  <small style={{ lineHeight: "10px", display: "block" }}>
                    <Icon
                      f7="chevron_right_2"
                      style={{ margin: "auto", fontSize: "12px" }}
                    ></Icon>
                    menu
                  </small>
                </th>
                <th>
                  <div style={{ width: "60px" }}>&nbsp;</div>
                </th>
                {this.props.data.merchants &&
                this.props.data.merchants[
                  this.props.f7route.params.merchantID
                ] &&
                this.props.data.merchants[this.state.which].menuCategories ? (
                  this.props.data.merchants[this.state.which].menuCategories
                    .sort()
                    .map((value, index) => (
                      <th
                        className="label-cell"
                        key={index}
                        onClick={(event) => {
                          this.$f7.methods.scrollTo(
                            this.$f7,
                            `#menu-${value.trim().split(" ").join("")}`
                          );
                        }}
                      >
                        <small
                          style={{ whiteSpace: "nowrap", padding: "10px" }}
                        >
                          {value}
                        </small>
                      </th>
                    ))
                ) : (
                  <th
                    className="label-cell"
                    onClick={(event) => {
                      this.$f7.methods.scrollTo(this.$f7, `#menu-none`);
                    }}
                  >
                    <small style={{ whiteSpace: "nowrap", padding: "10px" }}>
                      No items in menu
                    </small>
                  </th>
                )}
              </tr>
            </thead>
          </table>
        </Toolbar>

        {/* Swipe to close store details sheet */}
        <Sheet
          className="store-details-sheet"
          style={{
            height: "auto",
            "--f7-sheet-bg-color": "transparent",
            marginTop: "-20px",
          }}
          swipeToClose
          backdrop
        >
          <PageContent
            style={{
              borderTopRightRadius: "20px",
              borderTopLeftRadius: "20px",
              backgroundColor: "#fff",
            }}
          >
            <BlockTitle large>Hello!</BlockTitle>
            <Block>
              <p style={{ lineHeight: 3 }}>
                Welcome to{" "}
                {
                  this.props.data.merchants[
                    this.props.f7route.params.merchantID
                  ]?.businessProfile.name
                }{" "}
                page here on Easychaw,{" "}
                {this.props.data.merchants[this.props.f7route.params.merchantID]
                  ?.businessProfile?.city &&
                  "We are located in " +
                    this.props.data.merchants[
                      this.props.f7route.params.merchantID
                    ]?.businessProfile?.city +
                    ". "}
                <br />
                We are available on the following days:
              </p>

              <table className="store-operating-days-tbl">
                <thead>
                  <tr>
                    <th>Days</th>
                    <th>Open</th>
                    <th>Close</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(this.state.shortOperationDays).map((day) =>
                    this.props.data.merchants[
                      this.props.f7route.params.merchantID
                    ]?.businessProfile?.operationDays.includes(day) ? (
                      <tr
                        key={day}
                        style={
                          this.nowAvailableDay(day)
                            ? {
                                borderLeft: "4px solid #ccc",
                                backgroundColor: "#f3f3f3",
                              }
                            : {}
                        }
                      >
                        <td>{day}</td>
                        <td>
                          {this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ]?.businessProfile?.operationTimes?.[day]?.open ||
                            this.props.data.merchants[
                              this.props.f7route.params.merchantID
                            ]?.businessProfile?.operationStartTime}
                        </td>
                        <td>
                          {this.props.data.merchants[
                            this.props.f7route.params.merchantID
                          ]?.businessProfile?.operationTimes?.[day]?.close ||
                            this.props.data.merchants[
                              this.props.f7route.params.merchantID
                            ]?.businessProfile?.operationCloseTime}
                        </td>
                      </tr>
                    ) : (
                      <tr
                        key={day}
                        style={
                          this.nowAvailableDay(day)
                            ? {
                                borderLeft: "4px solid #ccc",
                                backgroundColor: "#f3f3f3",
                              }
                            : {}
                        }
                      >
                        <td>{day}</td>
                        <td colSpan="2">Closed</td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>

              <b>
                <em>
                  {
                    this.props.data.merchants[
                      this.props.f7route.params.merchantID
                    ]?.businessProfile?.slogan
                  }
                </em>
              </b>
            </Block>
          </PageContent>
        </Sheet>
      </Page>
    );
  }

  componentDidMount() {
    const dateTimeInterval = setInterval(() => {
      getCurrentTime((error, currentDateTime) => {
        if (error) {
          return console.log(error);
        }

        this.setState({
          ...this.state,
          currentDateTime,
        });
      });
    }, 30000);

    this.setState({
      ...this.state,
      dateTimeInterval,
    });
  }

  componentWillUnmount() {
    if (this.state.dateTimeInterval) {
      clearInterval(this.state.dateTimeInterval);
      this.setState({
        ...this.state,
        dateTimeInterval: null,
      });
    }
  }

  //events
  onPageAfterIn() {
    if (
      this.props.data.merchants &&
      this.props.data.merchants[this.props.f7route.params.merchantID]
    ) {
      const { businessProfile: merchantProfile } =
        this.props.data.merchants[this.props.f7route.params.merchantID];

      this.setState({
        ...this.state,
        merchantDetails: merchantProfile,
      });
    }
    // open popup for porpular meal item
    if (
      this.props.f7route.params.productID != undefined &&
      !this.props.ordered.loading &&
      this.props.ordered.products
    ) {
      const dataFromFilteredProductId = this.props.ordered.products.filter(
        (p) =>
          p.merchantId === this.props.f7route.params.merchantID &&
          p.id === this.props.f7route.params.productID
      )[0];

      const routeProductIDData = {
        productName: dataFromFilteredProductId.name,
        price: dataFromFilteredProductId.price,
        image: dataFromFilteredProductId.image.URL,
        productId: dataFromFilteredProductId.id,
        merchantId: dataFromFilteredProductId.merchantId,
        stocked: dataFromFilteredProductId.stocked,
        merchantName:
          this.props.data.merchants &&
          this.props.data.merchants[this.props.f7route.params.merchantID] &&
          this.props.data.merchants[dataFromFilteredProductId.merchantId]
            .businessProfile.name,
        merchantGeoLoc:
          this.props.data.merchants &&
          this.props.data.merchants[this.props.f7route.params.merchantID] &&
          this.props.data.merchants[dataFromFilteredProductId.merchantId]
            .businessProfile.geoLoc,
        text: dataFromFilteredProductId.text,
        preparationTime: dataFromFilteredProductId.preparationTime,
        discount: dataFromFilteredProductId.discount,
        delivery: dataFromFilteredProductId.delivery,
        deliveryMeans: dataFromFilteredProductId.deliveryMeans,
      };
      this.openPopup(routeProductIDData);
    }
  }

  openPopup(data) {
    const self = this;
    this.setState({
      ...this.state,
      popupOpened: true,
      popupData: {
        ...this.state.popupData,
        productName: data.productName,
        price: data.price,
        image: data.image,
        stocked: data.stocked,
        productId: data.productId,
        merchantId: data.merchantId,
        merchantName: data.merchantName,
        merchantGeoLoc: data.merchantGeoLoc,
        text: data.text,
        preparationTime: data.preparationTime,
        discount: data.discount,
        delivery: data.delivery,
        deliveryMeans: data.deliveryMeans,
      },
    });
  }

  async addOrder() {
    // check merchant distance from user if above 50km
    this.$f7.preloader.show();

    getCurrentTime((error, currentDateTime) => {
      if (error) {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: "Cannot place order something went wrong.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 6000,
        });

        return this.setState({
          popupOpened: false,
          popupData: {
            productName: "",
            price: "",
            image: "",
            count: 1,
            productId: "",
            merchantId: "",
          },
        });
      }

      if (
        convertDistance(
          getDistance(
            this.props.discover.geoLoc,
            this.state.popupData.merchantGeoLoc
          ),
          "km"
        ) > 50
      ) {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: "Cannot place order from vendors above 50km of your current location.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 6000,
        });

        return this.setState({
          popupOpened: false,
          popupData: {
            productName: "",
            price: "",
            image: "",
            count: 1,
            productId: "",
            merchantId: "",
          },
        });
      }

      if (
        !isMerchantOpen(
          currentDateTime,
          this.props.data.merchants?.[this.props.f7route.params.merchantID]
            .businessProfile.operationDays,
          this.props.data.merchants?.[this.props.f7route.params.merchantID]
            .businessProfile.operationTimes,
          this.props.data.merchants?.[this.props.f7route.params.merchantID]
            .businessProfile.operationStartTime,
          this.props.data.merchants?.[this.props.f7route.params.merchantID]
            .businessProfile.operationCloseTime
        )
      ) {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: "Oops! Sorry we are closed and can not take your order at the moment.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 6000,
        });

        return this.setState({
          popupOpened: false,
          popupData: {
            productName: "",
            price: "",
            image: "",
            count: 1,
            productId: "",
            merchantId: "",
          },
        });
      }

      const order = {
        merchantId: this.state.popupData.merchantId,
        merchantName: this.state.popupData.merchantName,
        package: {
          productId: this.state.popupData.productId,
          count: this.state.popupData.count,
        },
      };

      if (localStorage.getItem("cart")) {
        let cart = JSON.parse(localStorage.getItem("cart"));

        if (cart.find((cart) => cart.merchantId === order.merchantId)) {
          if (
            cart
              .find((cart) => cart.merchantId === order.merchantId)
              .packages.find((c) => c.productId === order.package.productId)
          ) {
            let index;
            let pIndex;
            cart.forEach((cart, i) => {
              if (cart.merchantId === order.merchantId) {
                index = i;
                cart.packages.forEach((p, j) => {
                  if (p.productId === order.package.productId) {
                    pIndex = j;
                  }
                });
              }
            });
            cart[index].packages[pIndex].count =
              Number(cart[index].packages[pIndex].count) +
              Number(order.package.count);
            localStorage.setItem("cart", JSON.stringify(cart));
            this.props.dispatch({ type: CART, payload: cart });
            this.setState({
              popupOpened: false,
              popupData: {
                productName: "",
                price: "",
                image: "",
                count: 1,
                productId: "",
                merchantId: "",
                merchantName: "",
              },
            });
          } else {
            let index;
            cart.forEach((cart, i) => {
              if (cart.merchantId === order.merchantId) {
                index = i;
              }
            });

            // check free delivery
            if (
              checkFreeDelivery(
                cart[index].packages,
                this.props.data.products
              ) === this.props.data.products[order.package.productId].delivery
            ) {
              toast(this.$f7.toast, {
                text: "Cannot mix pick up products with delivery products in one merchant's cart",
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 6000,
              });

              return this.setState({
                popupOpened: false,
                popupData: {
                  productName: "",
                  price: "",
                  image: "",
                  count: 1,
                  productId: "",
                  merchantId: "",
                },
              });
            }

            cart[index].packages.push({
              productId: order.package.productId,
              count: order.package.count,
            });
            localStorage.setItem("cart", JSON.stringify(cart));
            this.props.dispatch({ type: CART, payload: cart });
            this.setState({
              popupOpened: false,
              popupData: {
                productName: "",
                price: "",
                image: "",
                count: 1,
                productId: "",
                merchantId: "",
              },
            });
          }
        } else {
          cart.push({
            merchantId: order.merchantId,
            merchantName: order.merchantName,
            packages: [
              {
                ...order.package,
              },
            ],
          });
          localStorage.setItem("cart", JSON.stringify(cart));
          this.props.dispatch({ type: CART, payload: cart });
        }
      } else {
        localStorage.setItem(
          "cart",
          JSON.stringify([
            {
              merchantId: order.merchantId,
              merchantName: order.merchantName,
              packages: [
                {
                  ...order.package,
                },
              ],
            },
          ])
        );
        this.props.dispatch({
          type: CART,
          payload: [
            {
              merchantId: order.merchantId,
              merchantName: order.merchantName,
              packages: [
                {
                  ...order.package,
                },
              ],
            },
          ],
        });
        this.setState({
          popupOpened: false,
          popupData: {
            productName: "",
            price: "",
            image: "",
            count: 1,
            productId: "",
            merchantId: "",
            merchantName: "",
          },
        });
        // }
      }

      this.$f7.preloader.hide();
    });
  }

  // current day
  nowAvailableDay(day) {
    let d = new Date();
    let n = d.getDay();
    let days = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };
    if (days[day] == n) return true;
  }

  // handle zoom
  handleZoomChange(e) {
    this.setState({
      ...this.state,
      isZoomed: e,
    });
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: { ordered, data },
  cart,
  discover,
}) => ({
  auth,
  profile,
  ordered,
  data,
  cart,
  discover,
});

const enhance = compose(
  firestoreConnect([new Collections("products")]),
  connect(mapStateToProps)
);

export default enhance(Store);
